import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Check Circle Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M183.073 92.226c3.773 3.769 3.773 9.884 0 13.653l-67.545 67.545c-3.769 3.773-9.884 3.773-13.653 0l-28.948-28.948c-5.255-5.255-2.85-14.229 4.328-16.152a9.65 9.65 0 0 1 9.326 2.498l22.12 22.133 60.718-60.73c3.77-3.773 9.885-3.773 13.654 0M253.44 128c0 96.564-104.533 156.916-188.16 108.634s-83.627-168.986 0-217.268A125.44 125.44 0 0 1 128 2.56c69.248.073 125.367 56.192 125.44 125.44m-19.298 0c0-81.708-88.452-132.775-159.213-91.921s-70.76 142.988 0 183.842A106.16 106.16 0 0 0 128 234.141c58.593-.066 106.075-47.548 106.142-106.141" }, null, -1)
  ]))]))
}
export default { render: render }